var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21 21H10c-3.3 0-4.95 0-5.975-1.025S3 17.3 3 14V3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 10v11M18 13v8M8 13v7M21 7.987c-1.84 0-3.808.256-5.123-1.494-1.497-1.99-4.257-1.99-5.754 0C8.808 8.243 6.84 7.987 5 7.987H3"
  })));
};
export default SvgAnalytics;